import { render, staticRenderFns } from "./EventCategoryBadge.vue?vue&type=template&id=7c92a306&scoped=true&"
import script from "./EventCategoryBadge.vue?vue&type=script&lang=js&"
export * from "./EventCategoryBadge.vue?vue&type=script&lang=js&"
import style0 from "./EventCategoryBadge.vue?vue&type=style&index=0&id=7c92a306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92a306",
  null
  
)

export default component.exports